import { NotificationBell } from "@dashboard/notifications/NotificationBell";
import { Box } from "@saleor/macaw-ui-next";

import { AppHeaderProfile } from "./AppHeaderProfile";
import { AppHeaderSearch } from "./AppHeaderSearch";

/**
 * Global application header that sits at the top of the content area (right of
 * the sidebar) and above each page's per-page TopNav. Holds the command search
 * (left) and notifications + profile (right).
 */
export const AppHeader = () => (
  <Box
    as="header"
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={4}
    paddingX={5}
    height={12}
    flexShrink="0"
    backgroundColor="default1"
    borderBottomWidth={1}
    borderBottomStyle="solid"
    borderColor="default1"
    position="sticky"
    top={0}
    zIndex="2"
    data-test-id="app-header"
  >
    <Box display="flex" alignItems="center" flexGrow="1" __minWidth="0">
      <AppHeaderSearch />
    </Box>
    <Box display="flex" alignItems="center" gap={2} flexShrink="0">
      <NotificationBell />
      <AppHeaderProfile />
    </Box>
  </Box>
);
